import { render } from "./uploader.vue?vue&type=template&id=a08276b4&scoped=true"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"

import "./uploader.vue?vue&type=style&index=0&id=a08276b4&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a08276b4"]])

export default __exports__